module.exports = __webpack_public_path__ + "static/media/wowza-logo.b2302191.svg";